import React from "react";
import { Button, Form, Input, Modal } from "antd";
import { isNotOverStep1 } from "./../util";
import MoneyInput from "./../MoneyInput";
import TargetAccount from "./../TargetAccount";
import { mapCode2LinkOfQQDigitalCoin, formItemLayout, tailFormItemLayout } from "$ACTIONS/constantsData";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { sendPiwikEventAtUrl, sendPiwikEvent, sendPiwikEventWithEventValue } from "$ACTIONS/PiwikUtil";
import { CommonPostPay } from "$DATA/wallet";
import FinishStep from "../FinishStep/";

const { Item } = Form;

class JDP extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            targetValue: "", // 目标账户State值
            targetName: "", // 目标账户名称
            bonusVal: 0, // 可申请优惠Val值
            bonusName: "", // 可申请优惠名称
        };

        this.payTypeCode = "QQ"; // 当前支付方式Code
        this.mapCode2Link = mapCode2LinkOfQQDigitalCoin;
        const mapCode2LinkKeys = Object.keys(this.mapCode2Link)
        this.isQQEBpay = props.payMethodList.some(item =>
            item.code === "QQ" && item.availableMethods.some(method => mapCode2LinkKeys.indexOf(method.methodCode.toLowerCase())!==-1));
        this.isJustQQ = !this.isQQEBpay; // is enable QQ
    }
    componentDidMount() {
        sendPiwikEventAtUrl('deposit_digital_coin', 'DigitalCoin Deposit Page',
            'Deposit', 'Switch to DigitalCoin', 'Deposit_C_DigitalCoin');
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.Finish !== this.state.Finish) {
            this.props.setPromoBannerVisible && this.props.setPromoBannerVisible(
                isNotOverStep1(this.state.Finish, 'Finish'));
        }
    }
    payConfirm = (e) => {
        e.preventDefault();
        if (typeof this.props.depositStatusCheck() === "undefined") return; // 未完成真实姓名验证则呼出完善弹窗
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let piwikCoinType = this.isQQEBpay ? this.getPiwikCoinTypeValue(this.refs.Channeldefault?.state.Channeldefault) : '';
                this.props.setLoading(true);
                CommonPostPay(
                    {
                        methodcode: this.refs.Channeldefault?.state.Channeldefault,
                        accountHolderName: "",
                        accountNumber: "0",
                        amount: values.money,
                        bankName: "",
                        bonusCoupon: values.bonusCode || "",
                        cardExpiryDate: "",
                        cardName: "",
                        cardNumber: "",
                        cardPIN: "",
                        charges: 0,
                        couponText: "",
                        depositingBankAcctNum: "",
                        depositingWallet: this.state.targetValue, // 目标账户Code,
                        domainName: ApiPort.LOCAL_HOST,
                        fileBytes: "",
                        fileName: "",
                        isMobile: false,
                        isPreferredWalletSet: false, // 是否设为默认目标账户,
                        isSmallSet: false,
                        language: "zh-cn",
                        mgmtRefNo: "Fun88Desktop",
                        offlineDepositDate: "",
                        offlineRefNo: "0",
                        paymentMethod: this.payTypeCode, // current is 'QQ', future might be not
                        refNo: "0",
                        secondStepModel: null,
                        successUrl: ApiPort.LOCAL_HOST,
                        transactionType: "Deposit",
                        transferType: null,
                        blackBoxValue: window.E2GetBlackbox
                            ? window.E2GetBlackbox().blackbox == "" ||
                              window.E2GetBlackbox().blackbox == undefined
                                ? ""
                                : window.E2GetBlackbox().blackbox
                            : "",
                        e2BlackBoxValue: window.E2GetBlackbox
                            ? window.E2GetBlackbox().blackbox == "" ||
                              window.E2GetBlackbox().blackbox == undefined
                                ? ""
                                : window.E2GetBlackbox().blackbox
                            : "",
                    },
                    (res) => {
                        this.props.setLoading(false);
                        if (!res.isSuccess) { // copy from /ODP/index.js
                            let firstErr = res.errors && res.errors.length && res.errors[0];
                            let errCode = firstErr?.errorCode;
                            let _title = '温馨提醒';
                            let _okText = '知道了';
                            let _content = '';
                            let _onOkFunc = undefined;
                            const IS_ERR_P101116 = errCode==='P101116';
                            const IS_ERR_P101053 = errCode==='P101053';
                            const IS_ERR_P101019 = errCode==='P101019';
                            if (errCode) {
                                // setup _title _okText
                                if (IS_ERR_P101116 || IS_ERR_P101053 || IS_ERR_P101019) {
                                    _title = '重要提示';
                                    _okText = '好的';
                                }
                                // setup _content _onOkFunc
                                const getContent = (res, opt) => {
                                    return (<div>
                                            <p style={{marginBottom:'1em'}}>请耐心等待,您有一项存款申请正在处理中。</p>
                                            <div style={{background:'#efeff4', borderRadius:8, padding:16, marginBottom:'1em'}}>
                                                <p style={{color:'#9a9a9a', marginBottom:0}}>存款编号: {res?.result?.lastDepositID}</p>
                                                <p style={{color:'#9a9a9a', marginBottom:0}}>存款金額: {res?.result?.lastDepositAmount}</p>
                                            </div>
                                            {opt.IS_P101116 ? <p>请等到处理完毕后再提交其他存款申请。</p> : null}
                                            {opt.IS_P101053 ? <p>注意:不允许重复提交相同金额,请提交其他金额进行存款。</p> : null}
                                            </div>)
                                }
                                if (IS_ERR_P101116) {
                                    // 前筆交易處理中
                                    _content = getContent(res, {IS_P101116: true})
                                } else if (IS_ERR_P101053) {
                                    // 提交重複金額
                                    _content = getContent(res, {IS_P101053: true})
                                } else if (IS_ERR_P101019) {
                                    _content = res && res.errors && res.errors.length && res.errors[0].description && (<p>{res.errors[0].description}</p>); // copy ODP code for _content
                                }
                            }
                            if (!_content) {
                                if (res && res.errors && res.errors.length
                                    && (res.errors[0].description||res.errors[0].message||res.errors[0].errorCode)
                                    ) {
                                    // Try to display readable content for user
                                    _content = (res.errors[0].description ? res.errors[0].description : '')
                                                        + (res.errors[0].message ? (' ' + res.errors[0].message) : '')
                                                        + (res.errors[0].errorCode ? (' (' + res.errors[0].errorCode) + ')' : '')
                                } else {
                                    // Display unexpected error using JSON directly
                                    _content = 'unknow error: ' + JSON.stringify(res)
                                }
                            }
                            Modal.info({
                                className: 'confirm-modal-of-public',
                                icon: <div />,
                                title: _title,
                                width: 355,
                                okText: _okText,
                                okButtonProps: {
                                    shape: 'round'
                                },
                                onOk: _onOkFunc,
                                content: (
                                    <div className="exchange-hint">
                                        <div className="content" style={{ textAlign: 'left' }}>
                                            {_content}
                                        </div>
                                    </div>)
                            });

                            if (this.isQQEBpay) {
                            let piwikErrNote = res?.errors?.[0]?.message || res?.errors?.[0]?.errorCode || res?.errors?.[0]?.description;
                            sendPiwikEventWithEventValue('Deposit',
                                'Submit Deposit '+piwikCoinType,
                                'Deposit_'+piwikCoinType+'_S_Deposit',
                                '1',
                                [{customVariableKey:'Deposit_'+piwikCoinType+'_S_Deposit_Amount', customVariableValue:values.money},
                                 {customVariableKey:'Deposit_'+piwikCoinType+'_S_Deposit_ErrorMsg', customVariableValue:piwikErrNote}]
                            );
                            return;
                            }
                        }
                        let resData = res;
                        res = resData.result;
                        res.isSuccess = resData.isSuccess;
                        if (res.isSuccess) {
                            this.props.thirdPartyPay(res, undefined, {isOriginQQ: !this.isQQEBpay});
                            this.setState({
                                FinishData: res,
                                Finish: true,
                            });
                            this.props.form.resetFields();

                            if (this.isQQEBpay) {
                            sendPiwikEventWithEventValue('Deposit',
                                'Submit Deposit '+piwikCoinType,
                                'Deposit_'+piwikCoinType+'_S_Deposit',
                                '2',
                                [{customVariableKey:'Deposit_'+piwikCoinType+'_S_Deposit_Amount', customVariableValue:values.money}]
                            );
                            }
                        }
                    } // end of (res) => {
                , {IS_ALREADY_HANDLE_SUCCESS_FALSE_UI_UX: true});
            }
        });

        if (this.isJustQQ) {
        Pushgtagdata("Deposit​", "Submit​", "Submit_onlineQQpay_Deposit");
        }
    };

    goRecord = () => {
        this.props.onCancel();
        this.props.goUserCenter("records");
        sessionStorage.setItem("selectTabKey", "deposit");
        typeof global.changeRecordFilterType === "function" &&
            global.changeRecordFilterType("deposit");
    };

    getPiwikCoinTypeValue(_curChanneldefaultValue) {
        return typeof _curChanneldefaultValue === 'string' ? _curChanneldefaultValue.replace(/_DP$/i, '_WD') : 'COINTYPE';
    }

    render() {
        let { setting } = this.props.currDepositDetail; // 当前支付方式的详情
        const {
            getFieldsError,
            getFieldValue,
            getFieldDecorator,
            setFieldsValue,
            setFields,
            getFieldError,
        } = this.props.form;
        const { targetValue, bonusVal, Finish, FinishData } = this.state;
        const moneyValue = parseInt(getFieldValue("money"));
        const curChanneldefaultValue = this.refs.Channeldefault?.state.Channeldefault;
        const curChanneldefaultValueLower = typeof curChanneldefaultValue === 'string' ? curChanneldefaultValue.toLowerCase() : '';

        const curChanneldefaultName = this.props.payMethodList.filter(item => item.code === "QQ")[0]?
                    .availableMethods.filter(_ => _.methodCode==curChanneldefaultValue)[0]?.methodType;

        return (
            <React.Fragment>
                {/* 成功提交的页面 */}
                {Finish && (
                    <FinishStep
                        collectionInfo={FinishData}
                        Time={"10:00"}
                        goRecord={() => {
                            this.goRecord();
                        }}
                        goHome={() => {
                            this.props.onCancel("ToHome");
                        }}
                    />
                )}
                {!Finish && (
                    <Form
                        className="form-wrap"
                        {...formItemLayout}
                        onSubmit={(e) => {
                            let lodash = false;
                            if (!this.lodash) {
                                this.payConfirm(e);
                                lodash = true;
                            }
                            setTimeout(() => {
                                lodash = false;
                            }, 2000);
                        }}
                    >
                        <div
                            className="modal-prompt-info"
                            style={{
                                display: this.props.isShowBankCardVerif
                                    ? "block"
                                    : "none",
                                color: "#2962FF",
                                textAlign: "center",
                                cursor: "pointer",
                            }}
                            onClick={() => this.props.openBankAccountVerif()}
                        >
                            <span className="spanText">
                                开启更多充值和提现方式
                            </span>
                            <p className="pText">
                                点击上方按钮完成验证，小同为您承担网银转账 5%
                                手续费
                            </p>
                        </div>
                        <MoneyInput
                            {...this.props.dialogTabKey}
                            getFieldDecorator={getFieldDecorator}
                            payTypeCode={this.payTypeCode}
                            payMethodList={this.props.payMethodList}
                            setCurrDepositDetail={
                                this.props.setCurrDepositDetail
                            }
                            setting={setting}
                            setFieldsValue={setFieldsValue}
                            setLoading={this.props.setLoading}
                            ref="Channeldefault"
                            setFields={setFields}
                            getFieldError={getFieldError}
                            getFieldValue={getFieldValue}
                        />
                        {/* {moneyValue && !!setting.charges ? <Item label="实际到账">
							<Input size="large" className="tlc-input-disabled" disabled={true} value={moneyValue + setting.charges} />
						</Item> : null} */}
                        <TargetAccount
                            {...this.props.dialogTabKey}
                            getFieldValue={getFieldValue}
                            getFieldDecorator={getFieldDecorator}
                            setLoading={this.props.setLoading}
                            targetValue={targetValue}
                            setTargetValue={(v, name) => {
                                this.setState({
                                    targetValue: v,
                                    targetName: name,
                                });
                            }}
                            bonusVal={bonusVal}
                            setBonusValue={(v, name) => {
                                this.setState({ bonusVal: v, bonusName: name });
                            }}
                        />
                        <Item {...tailFormItemLayout}>
                            <div className="btn-wrap">
                                <Button
                                    disabled={
                                        Object.values(getFieldsError()).some(
                                            (v) => v !== undefined
                                        ) || !getFieldValue("money")
                                    }
                                    size="large"
                                    type="primary"
                                    htmlType="submit"
                                    block
                                >
                                    提交
                                </Button>
                            </div>
                        </Item>
                        {/* <div className="modal-prompt-info">
							收款商户将会不定时变动，请在充值前到此页面提交申请获取最新二维码。存款过程中切勿重复扫码，多次扫码会导致系统记录异常而无法成功到账。
						</div> */}
                    </Form>
                )}

                {/* 立即下載 */}
                <div style={{background:'#fff', borderRadius:8, padding:12, display:curChanneldefaultValue ? '' : 'none'}}>
                    <Button onClick={()=>{
                        let piwikCoinType = this.getPiwikCoinTypeValue(curChanneldefaultValue);
                        sendPiwikEvent('Deposit', 'Go to '+piwikCoinType+' Website', 'Deposit_'+piwikCoinType+'_C_Download')
                    }} style={{float:'right',marginTop:7,marginRight:5}} type="primary" ghost>
                        <a href={this.mapCode2Link[curChanneldefaultValueLower||'UNDEF']} target="_blank">
                        立即下载
                        </a>
                    </Button>
                    <img src={"/cn/img/DIGITALCOIN/" + curChanneldefaultValue + ".svg"} alt="" style={{float:'left',width:42,height:42,marginRight:10}} />
                    <div style={{color:'#666'}}>
                        <strong style={{color:'#222',fontSize:16,display:'block'}}>{curChanneldefaultName}</strong>
                        便捷交易秒到账
                    </div>
                </div>

                {/* 温馨提示 */}
                <div className="deposit-help-wrap">
                    <h4 style={{display: this.payTypeCode=='QQ' && !curChanneldefaultValue ? 'none' : ''}}>乐天使温馨提醒：</h4>
                    {this.refs.Channeldefault &&
                    this.refs.Channeldefault.state.Channeldefault == "QQRP" ? (
                        <ul>
                            <li>
                                首先登入您的QQ账号，打开【我的QQ钱包】&#8250;【全部应用】&#8250;【QQ红包】的【QQ面对面红包】{" "}
                            </li>
                            <li>
                                在【QQ面对面红包】页面输入存款金额，点击确认之后将回生成二维码{" "}
                            </li>
                            <li>
                                将面对面红包二维码进行截图/若无法成功截图，若无法成功截图，建议使用其他设备进行拍摄
                            </li>
                            <li>
                                请记得在QQ红包支付渠道过程中，点击上传二维码截图以便顺利完成存款
                            </li>
                        </ul>
                    ) : (
                        this.isQQEBpay ? (<ul style={{display:curChanneldefaultValue ? '' : 'none'}}>
                            {curChanneldefaultValueLower==='ebpay_dp' && <EBpayReminder link={this.mapCode2Link[curChanneldefaultValueLower||'UNDEF']} />}
                            {curChanneldefaultValueLower==='kdoupay_dp' && <KDoupayReminder link={this.mapCode2Link[curChanneldefaultValueLower||'UNDEF']} />}
                            {curChanneldefaultValueLower==='goubaopay_dp' && <GouBaopayReminder link={this.mapCode2Link[curChanneldefaultValueLower||'UNDEF']} />}
                            {curChanneldefaultValueLower==='hipay_dp' && <HIpayReminder link={this.mapCode2Link[curChanneldefaultValueLower||'UNDEF']} />}
                            {curChanneldefaultValueLower==='c_808pay_dp' && <C808payReminder link={this.mapCode2Link[curChanneldefaultValueLower||'UNDEF']} />}
                            {curChanneldefaultValueLower==='c_988pay_dp' && <C988payReminder link={this.mapCode2Link[curChanneldefaultValueLower||'UNDEF']} />}
                            {curChanneldefaultValueLower==='jdpay_dp' && <JDpayReminder link={this.mapCode2Link[curChanneldefaultValueLower||'UNDEF']} />}
                            </ul>) :
                        <ul>
                            <li>键入存款金额。 </li>
                            <li>
                                点击提交后，页面下方会自动生成二维码(此二维码仅本次有效)
                                。{" "}
                            </li>
                            <li>使用手机打开QQ，扫描二维码转至付款页面。 </li>
                            <li>确保信息无误提交即可。</li>
                            <li>QQ支付到账时间为15分钟左右。 </li>
                            <li>QQ支付不支持信用卡存款。</li>
                        </ul>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

const EBpayReminder = props => (<><li>1 EB 币 = 1 人民币</li><li>存款时，请复制收款地址或使用 EBpay APP 扫描二维码。</li>
  <li>请勿向上述地址存款任何非 EB 资产，避免造成资金损失。</li>
  <li>此存款方式仅支持使用 EBpay 进行存款，若未安装 EBpay App，请先下载安装。
  </li></>);
const GouBaopayReminder = props => (<><li>1 G 币 = 1 人民币</li><li>存款时，请复制收款地址或使用购宝钱包 APP 扫描二维码。</li><li>请勿向上述地址存款任何非购宝资产，避免造成资金损失。</li><li>此存款方式仅支持使用购宝钱包进行存款，若未安装购宝钱包 App，请先下载安装。</li></>)
const KDoupayReminder = props => (<><li>1 K 豆 = 1 人民币</li><li>存款时，请复制收款地址或使用 K豆钱包 APP 扫描二维码。</li><li>请勿向上述地址存款任何非 K豆资产，避免造成资金损失。</li><li>此存款方式仅支持使用 K豆钱包进行存款，若未安装 K豆钱包 App，请先下载安装。</li></>)
const HIpayReminder = props => (<><li>1 CNYT 币 = 1 人民币</li><li>存款时，请复制收款地址或使用嗨钱包 APP 扫描二维码。</li><li>请勿向上述地址存款任何非嗨钱包资产，避免造成资金损失。</li><li>此存款方式仅支持使用嗨钱包进行存款，若未安装嗨钱包 App，请先下载安装。</li></>)
const C808payReminder = props => (<><li>1 808 币 = 1 人民币</li><li>存款时，请复制收款地址或使用 808钱包 APP 扫描二维码。</li><li>请勿向上述地址存款任何非 808 资产，避免造成资金损失。</li><li>此存款方式仅支持使用 808钱包 进行存款，若未安装 808钱包 App，请先下载安装。</li></>)
const C988payReminder = props => (<><li>1 988 币 = 1 人民币</li><li>存款时，请复制收款地址或使用 988钱包 APP 扫描二维码。</li><li>请勿向上述地址存款任何非 988钱包资产，避免造成资金损失。</li><li>此存款方式仅支持使用 988钱包 进行存款，若未安装 988钱包 App，请先下载安装。</li></>)
const JDpayReminder = props => (<><li>1 JD 币 = 1 人民币</li><li>存款时，请复制收款地址或使用 JD钱包 APP 扫描二维码。</li><li>请勿向上述地址存款任何非 JD钱包资产，避免造成资金损失。</li><li>此存款方式仅支持使用 JD钱包进行存款，若未安装 JD钱包 APP，请先下载安装。</li></>)

export default Form.create({ name: "JDP" })(JDP);
